exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".vnis *,.vnis :after,.vnis :before{box-sizing:border-box}.vnis__input{-webkit-appearance:none;border:1px solid #ebebeb;float:left;font-size:16px;height:40px;margin:0;outline:none;text-align:center;width:calc(100% - 80px)}.vnis__input::-webkit-inner-spin-button,.vnis__input::-webkit-outer-spin-button{-webkit-appearance:none}.vnis__button{-webkit-appearance:none;transition:background .5s ease;background:#387e90;border:0;color:#fff;cursor:pointer;float:left;font-size:20px;height:40px;margin:0;width:40px}.vnis__button:hover{background:#469eb5}.vnis__button:focus{outline:1px dashed #69b2c5;outline-offset:-5px}", ""]);

// exports
